import Baobab from 'baobab'
import store from 'store'

export default function treeManipulationFactory(
  storeTreeConfig,
  migrate = () => ({})
) {
  const { version, key, save } = storeTreeConfig

  const tree = new Baobab(getCurrentTreeFromStore(), { immutable: false })

  if (save) {
    tree.on('update', () => {
      setCurrentTreeToStore(tree)
    })
  }

  function getCurrentTreeFromStore() {
    const currentStoreValue =
      process.env.NODE_ENV === 'production' && save ? store.get(key) || {} : {}

    if (currentStoreValue.version !== version) {
      return migrate(currentStoreValue.tree)
    }

    return currentStoreValue.tree
  }

  function setCurrentTreeToStore(tree) {
    store.set(key, {
      tree: tree.serialize(),
      version,
    })
  }

  function clearTreeFromStore() {
    store.set(key, {
      tree: {},
      version,
    })
  }

  return {
    tree,
    getCurrentTreeFromStore,
    setCurrentTreeToStore,
    clearTreeFromStore,
  }
}
